import React, { Component } from 'react'
import PlacesAutocomplete from 'react-places-autocomplete'

import './AldermanLookup.css'


const renderFunc = ({ getInputProps, getSuggestionItemProps, loading, suggestions }) => (
  <div className="autocomplete-root">
    <input {...getInputProps({placeholder: "Enter your address"})} />
    <div className="autocomplete-dropdown-container">
      {loading && <div>Loading...</div>}
      {suggestions.map(suggestion => (
        <div {...getSuggestionItemProps(suggestion)}>
          <span>{suggestion.description}</span>
        </div>
      ))}
    </div>
  </div>
)

/**
 * A lookup form for your Alderman.
 *
 * Uses [react-places-autocomplete](https://github.com/hibiken/react-places-autocomplete)
 * to make autocompleting addresses easier.
 */
class AldermanLookup extends Component {
  constructor(props) {
    super(props)

    this.state = {
      address: ''
    }

    // Bind event handler methods to `this`
    // See https://reactjs.org/docs/handling-events.html
    this.handleChange = this.handleChange.bind(this)
    this.handleSelect = this.handleSelect.bind(this)
  }

  handleChange(address) {
    this.setState({address})
  }

  handleSelect(address) {
    this.setState({address})

    this.props.onSelectAddress(address)
  }

	render() {
		return (
      <div className="AldermanLookup">
  		  <form>
          <PlacesAutocomplete
            value={this.state.address}
            onChange={this.handleChange}
            onSelect={this.handleSelect}>
            {renderFunc}
          </PlacesAutocomplete>
  			</form>
      </div>
		)
	}
}

export default AldermanLookup



// WEBPACK FOOTER //
// ./src/AldermanLookup.js